/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';

/**
 *
 * @export
 * @interface V2beta1Pipeline
 */
export interface V2beta1Pipeline {
  /**
   * Output. Unique pipeline ID. Generated by API server.
   * @type {string}
   * @memberof V2beta1Pipeline
   */
  pipeline_id?: string;
  /**
   * Required if name is not provided. Pipeline display name provided by user.
   * @type {string}
   * @memberof V2beta1Pipeline
   */
  display_name?: string;
  /**
   * Required if display_name is not provided. Pipeline name provided by user.
   * @type {string}
   * @memberof V2beta1Pipeline
   */
  name?: string;
  /**
   * Optional input field. A short description of the pipeline.
   * @type {string}
   * @memberof V2beta1Pipeline
   */
  description?: string;
  /**
   * Output. Creation time of the pipeline.
   * @type {Date}
   * @memberof V2beta1Pipeline
   */
  created_at?: Date;
  /**
   * Input. A namespace this pipeline belongs to.
   * Causes error if user is not authorized to access the specified namespace.
   * If not specified in CreatePipeline, default namespace is used.
   * @type {string}
   * @memberof V2beta1Pipeline
   */
  namespace?: string;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof V2beta1Pipeline
   */
  error?: GoogleRpcStatus;
  /**
   * Optional. User-defined tags as key-value pairs associated with the pipeline.
   * Tags can be used to label and categorize pipelines.
   * Constraints:
   *   - Maximum 20 tags per pipeline.
   *   - Both key and value are limited to 63 characters.
   *   - Keys cannot be empty and must not contain the '.' character.
   * Tags can be filtered on when listing pipelines using the filter parameter
   * with keys prefixed by "tags."
   * (e.g., filter predicate key "tags.team" with string_value "ml-ops").
   * @type {{ [key: string]: string; }}
   * @memberof V2beta1Pipeline
   */
  tags?: { [key: string]: string };
}

/**
 * Check if a given object implements the V2beta1Pipeline interface.
 */
export function instanceOfV2beta1Pipeline(value: object): value is V2beta1Pipeline {
  return true;
}

export function V2beta1PipelineFromJSON(json: any): V2beta1Pipeline {
  return V2beta1PipelineFromJSONTyped(json, false);
}

export function V2beta1PipelineFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1Pipeline {
  if (json == null) {
    return json;
  }
  return {
    pipeline_id: json['pipeline_id'] == null ? undefined : json['pipeline_id'],
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    namespace: json['namespace'] == null ? undefined : json['namespace'],
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function V2beta1PipelineToJSON(json: any): V2beta1Pipeline {
  return V2beta1PipelineToJSONTyped(json, false);
}

export function V2beta1PipelineToJSONTyped(
  value?: V2beta1Pipeline | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_id: value['pipeline_id'],
    display_name: value['display_name'],
    name: value['name'],
    description: value['description'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    namespace: value['namespace'],
    error: GoogleRpcStatusToJSON(value['error']),
    tags: value['tags'],
  };
}
